import React from 'react'
import PropTypes from 'prop-types'

const SelectTemplate = props => (
  <div className="reset-state" style={{ display: 'inline-block' }}>
    <select
      value={props.selectedOption}
      onChange={props.handleSelect}
    >
      <option key="" value="" label="" />
      {props.templates.map(name => (
        <option key={name} value={name} label={name} />
      ))}
    </select>
    <button onClick={props.handleClick}>
      {'reset'}
    </button>
  </div>
)

SelectTemplate.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  templates: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
}

export default SelectTemplate



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/Auditor/SelectTemplate.js